import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _683b9fa5 = () => interopDefault(import('../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _5e654c67 = () => interopDefault(import('../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _4aa353f2 = () => interopDefault(import('../pages/contact-us.vue' /* webpackChunkName: "pages/contact-us" */))
const _89380fe4 = () => interopDefault(import('../pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */))
const _29b63f6f = () => interopDefault(import('../pages/orders/index.vue' /* webpackChunkName: "pages/orders/index" */))
const _073ea924 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _1ded7fae = () => interopDefault(import('../pages/signin.vue' /* webpackChunkName: "pages/signin" */))
const _059f969f = () => interopDefault(import('../pages/signup.vue' /* webpackChunkName: "pages/signup" */))
const _635b5197 = () => interopDefault(import('../pages/orders/_id.vue' /* webpackChunkName: "pages/orders/_id" */))
const _4b794d88 = () => interopDefault(import('../pages/products/_category/index.vue' /* webpackChunkName: "pages/products/_category/index" */))
const _34a5238e = () => interopDefault(import('../pages/reset-password/_token.vue' /* webpackChunkName: "pages/reset-password/_token" */))
const _61157627 = () => interopDefault(import('../pages/products/_category/_id/index.vue' /* webpackChunkName: "pages/products/_category/_id/index" */))
const _31bb856b = () => interopDefault(import('../pages/products/_category/_id/_product.vue' /* webpackChunkName: "pages/products/_category/_id/_product" */))
const _3410499b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _683b9fa5,
    name: "about-us"
  }, {
    path: "/cart",
    component: _5e654c67,
    name: "cart"
  }, {
    path: "/contact-us",
    component: _4aa353f2,
    name: "contact-us"
  }, {
    path: "/forgot-password",
    component: _89380fe4,
    name: "forgot-password"
  }, {
    path: "/orders",
    component: _29b63f6f,
    name: "orders"
  }, {
    path: "/products",
    component: _073ea924,
    name: "products"
  }, {
    path: "/signin",
    component: _1ded7fae,
    name: "signin"
  }, {
    path: "/signup",
    component: _059f969f,
    name: "signup"
  }, {
    path: "/orders/:id",
    component: _635b5197,
    name: "orders-id"
  }, {
    path: "/products/:category",
    component: _4b794d88,
    name: "products-category"
  }, {
    path: "/reset-password/:token?",
    component: _34a5238e,
    name: "reset-password-token"
  }, {
    path: "/products/:category/:id",
    component: _61157627,
    name: "products-category-id"
  }, {
    path: "/products/:category/:id/:product",
    component: _31bb856b,
    name: "products-category-id-product"
  }, {
    path: "/",
    component: _3410499b,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
